//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LinkDeviceIcon from '../../../common/icons/LinkDeviceIcon';
import Device from '../../../../service/device/device';

export default {
  name: 'LinkDevice',
  components: {
    LinkDeviceIcon,
  },
  props: {
    device: Device,
    origin: {
      type: String,
      default: () => null,
    },
  },
  methods: {
    handleLink() {
      if (this.device.type === 'apple' && (!window.platform || window.platform !== 'ios')) {
        this.$container.eventBus.emit('toggleAlert', {
          message: 'Open the PWR Lab app on your iPhone to connect with Apple.',
          messageSize: 'p',
        });
      } else if (this.origin) {
        this.$router.push({
          name: 'WhitelabelSetup',
          params: {
            device: this.device.type,
          },
          query: {
            origin: this.origin,
            device: this.device.type,
          },
        });
      } else {
        this.$router.push({
          name: 'setup',
          params: { device: this.device.type },
        });
      }
    },
    async unlinkDevice() {
      if (await this.confirmation()) {
        await this.device.unlink();
        this.$emit('unlinked');
      }
    },
  },
};
